import React, { Component } from 'react'
import { layout, Button, ExTable } from 'icsoc-antd-ex';
import UnionComponent from 'Components/union/unionComponent';
import actions from 'Actions/taskManage/interactivePath';
import tDetailActions from 'Actions/taskManage/detail';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Search from "./components/search"
import TableList from "./components/tableList"
import InteractionDetails from './components/InteractionDetails';
import { Form, message } from 'antd';
import * as echarts from 'echarts';
import "./index.less";

const { BaseContentMainHeader } = layout;
const FormItem = Form.Item;
class index extends UnionComponent {
    state = {
        tableListLoading: false,
    }
    componentDidMount() {
        this.props.actions.setState({ key: "echarts", value: echarts.init(document.getElementById('echarts')) })
        this.props.actions.setState({ key: "height", value: this.wrapper.offsetHeight })
    }
    export = (fileType) => {
        // if (this.props.tableListData.data.length == 0) {
        //     message.warning("暂无数据，不可导出")
        //     return;
        // }
        this.setTableListLoading()
        this.props.actions.interactDownload({ ...this.props.searchData, fileType }).then(res => { // 接口请求
            let fileName;
            try {
                fileName = decodeURIComponent(res.payload.headers["content-disposition"].split(" ")[1].split("=")[1]);
            } catch {
                fileName = `${Date.now()}.${fileType == "excel" ? "xlsx" : "csv"}`
            }
            message.success("导出成功");
            let blob;
            if (fileType == "excel") {
                blob = new Blob([res.payload.data], { type: 'application/vnd.ms-excel' })
            } else if (fileType == "csv") {
                blob = new Blob([res.payload.data], { type: 'text/csv,charset=UTF-8' })
            }
            let elink = document.createElement('a');
            elink.download = fileName // 下载文件名称
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            document.body.removeChild(elink) //下载完成移除元素
            window.URL.revokeObjectURL(elink) //释放掉blob对象
        }).finally(_ => {
            this.setTableListLoading()
        })
    }


    render() {
        let { tableListLoading } = this.state;


        return (
            <div id="interactivePath" ref={d => this.wrapper = d}>
                <BaseContentMainHeader title="交互轨迹统计">
                    <Form layout="inline">
                        <FormItem>
                            <Button type="primary" onClick={() => { this.export("csv") }}>
                                导出csv
                            </Button>
                        </FormItem>
                        <FormItem>
                            <Button onClick={() => { this.export("excel") }}>
                                导出excel
                            </Button>
                        </FormItem>
                    </Form>
                </BaseContentMainHeader>
                <Search getTableList={this.getCustomizeTableList} />
                <TableList loading={tableListLoading} setTableListLoading={this.setTableListLoading} getTableList={this.getCustomizeTableList} />
                {/* 交互详情 */}
                <InteractionDetails />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.taskManageInteractivePath,
    detailDrawerData: state.taskManageDetail.detailDrawerData,
});

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(actions, dispatch),
        detailActions: bindActionCreators(tDetailActions, dispatch)
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(index)
